var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.requiresAuth)?_c('nav-bar'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.$route.meta.requiresAuth)?_c('tab-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }